// A BOLINHA VERMELHA do ícone "E-mail" no menu de cima (Victor, 24/09: "assim
// como aparece no chat interno"). O número vem do servidor (Correio::NaoLidas,
// o mesmo leitor do contador da Entrada no trilho — os dois nunca discordam):
// e-mails não lidos na Entrada de toda caixa que a pessoa vê.
//
// Quando conta de novo:
// - ao ligar (o menu monta com o módulo ligado);
// - a cada aviso ao vivo do módulo (`CORREIO_MUDOU`: chegou, leu no celular…),
//   de QUALQUER tela do advup — a bolinha acende sem abrir o E-mail;
// - quando a tela do E-mail recarrega as pastas (`CORREIO_CONTAR`: leu,
//   marcou como não lida, mandou para a lixeira);
// - e a cada 2 minutos, rede de segurança se o canal ao vivo cair.
// Vários avisos juntos viram uma pergunta só (espera de 600 ms).
import { ref } from 'vue';
import CorreioAPI from 'dashboard/api/correio';
import { emitter } from 'shared/helpers/mitt';

export const CORREIO_CONTAR = 'CORREIO_CONTAR';
const A_CADA = 2 * 60 * 1000;

const total = ref(0);
let ligada = false;
let espera = null;
let relogio = null;

async function contar() {
  try {
    const { data } = await CorreioAPI.naoLidas();
    total.value = Number(data.total) || 0;
  } catch {
    // Sem rede ou módulo desligado agora: fica o último número, e a próxima
    // volta do relógio tenta de novo. A bolinha nunca derruba o menu.
  }
}

function pedir() {
  clearTimeout(espera);
  espera = setTimeout(contar, 600);
}

function ligar() {
  if (ligada) {
    pedir();
    return;
  }
  ligada = true;
  contar();
  emitter.on('CORREIO_MUDOU', pedir);
  emitter.on(CORREIO_CONTAR, pedir);
  relogio = setInterval(contar, A_CADA);
}

function desligar() {
  if (!ligada) return;
  ligada = false;
  total.value = 0;
  clearTimeout(espera);
  clearInterval(relogio);
  emitter.off('CORREIO_MUDOU', pedir);
  emitter.off(CORREIO_CONTAR, pedir);
}

export function useNaoLidasDoMenu() {
  return { total, ligar, desligar };
}
